"use client";
import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Text,
  Row,
  Columns,
  Box,
} from "@dxp-feed/ui";
import { useAppSelector } from "@/utils/hooks/reactUseCustomHooks";
import { addDataLayerProducts } from "@/helpers/dataLayer";
import Link from "@/components/Link";
import ImageWrapper from "@/components/ImageWrapper";
import { AemHost, GLOBAL_SEARCH_QUERY_PARAM_KEY } from "@/utils/constant";
import { SanitizeGlobalSearchInput } from "@/helpers/useCommonFunctions";
import { useSearchParams } from "next/navigation";
const HighlightCategory: React.FC = () => {
  const searchParams = new URLSearchParams(useSearchParams());
  const { RecipeCategories } = useAppSelector(
    (state) => state.getProductAemDataSlice
  );
  const searchQuery = SanitizeGlobalSearchInput(
    searchParams.get(GLOBAL_SEARCH_QUERY_PARAM_KEY) ?? ""
  );
  return (
    <Row>
      <Columns className="col-12">
        {RecipeCategories?.categoriestitle && (
          <Text
            as="h3"
            className={`!text-brandBlack font-extrabold !font-raleway text-2xl ${searchQuery.length ? "my-[26px]" : "mb-[26px]"}`}
          >
            {RecipeCategories?.categoriestitle}
          </Text>
        )}
      </Columns>
      {RecipeCategories?.recipesCategoriesList?.length > 0 && (
        <Box className="grid grid-cols-1 xs:grid-cols-2 md:grid-cols-4 gap-6 w-full mb-6 px-3">
          {RecipeCategories.recipesCategoriesList.map(
            (foodType: any, index: any) => (
              <Columns key={index + foodType.label}>
                <Box
                  as="div"
                  className="h-full"
                  onClick={() => {
                    addDataLayerProducts({
                      event: "category_cta",
                      tile_name: foodType?.label,
                      tile_position: index + 1,
                      page_title: document.title,
                    });
                  }}
                >
                  <Link href={`/${foodType.link}`} className="block h-full">
                    <Card className="!shadow-none !rounded-xl border border-grey300 h-full">
                      <CardHeader className="flex items-center justify-center !p-0 !border-[0px]">
                        <ImageWrapper
                          src={`${AemHost}${foodType?.image}`}
                          alt={foodType.label}
                          width={268.6}
                          height={154}
                          className="w-full object-cover"
                        />
                      </CardHeader>
                      <CardContent className="pt-2 pb-4 px-[18px]">
                        <CardTitle className="!text-base !text-grey950 font-bold">
                          {foodType.label}
                        </CardTitle>
                      </CardContent>
                    </Card>
                  </Link>
                </Box>
              </Columns>
            )
          )}
        </Box>
      )}
    </Row>
  );
};

export default HighlightCategory;
